<template>
  <listing-layout>
    <h1 class="sr-only" slot="heading">Dashboard</h1>
    <div slot="content">
      <h2 class="mb-3">Welcome {{ user }}</h2>
      <div class="alert alert-warning" v-if="status">{{ status }}</div>
      <div v-if="stats.length > 0" class="px-0">
        <h3 class="h6 mb-3">Your month at a glance:</h3>
        <ul class="list-unstyled mb-2 mb-md-0 row flex-wrap">
          <dashboard-stat v-for="(stat, index) in stats" :key="index" :stat="stat" :class="stat.class" :isEven="index % 2" />
        </ul>
      </div>
      <div class="px-0">
        <ul class="list-unstyled mb-0 row flex-wrap">
          <dashboard-block v-if="blocks.length > 0" v-for="(block, index) in blocks" :key="index" :block="block" @editBlock="blocksEdited" @blockRemoved="blocksEdited()" />
          <dashboard-new v-if="stats.length > 0" @addBlock="blocksEdited" />
        </ul>
      </div>
    </div>
  </listing-layout>
</template>

<script>
import axios from 'axios'
import listingLayout from '@/components/ListingLayout'
import dashboardStat from './DashboardStat'
import dashboardBlock from './DashboardBlock'
import dashboardNew from './DashboardNew'

export default {
  name: 'Dashboard',
  props: {
    status: String
  },
  components: {
    'listing-layout': listingLayout,
    'dashboard-stat': dashboardStat,
    'dashboard-block': dashboardBlock,
    'dashboard-new': dashboardNew
  },
  data() {
    return {
      user: '',
      stats: [],
      blocks: []
    }
  },
  computed: {
    blocksCount() {
      return this.$store.state.blocks.length
    }
  },
  watch: {
    blocksCount() {
      this.blocks = [...this.$store.state.blocks]
    }
  },
  mounted() {
    this.user = localStorage.getItem('first_name') === 'undefined' ? '' : localStorage.getItem('first_name')
    if (this.blocksCount > 0) {
      this.blocks = [...this.$store.state.blocks]
    }
    if (this.$isAdmin) {
      axios.get(`${this.$api}/admin/summary`).then((response) => {
        if (response.data.status === 'success') {
          this.stats.push({ name: 'New Registrations', value: response.data.newHorses, class: 'horses' })
          this.stats.push({ name: 'New Members', value: response.data.newUsers, class: 'members' })
          this.stats.push({ name: 'Payments Made', value: response.data.completedPayments, class: 'payments' })
          this.stats.push({ name: 'Payments To Action', value: response.data.pendingInvoices, class: 'invoices', link: 'Payments' })
          this.stats.push({ name: 'Pending Horse Updates', value: response.data.pendingHorseUpdates, class: 'horses', link: 'Horse Updates' })
        }
      })
    }
  },
  methods: {
    blocksEdited() {
      axios.get(`${this.$api}/current-date`).then((response) => {
        if (response.data.status === 'success') {
          this.$store.commit('setCurrentDate', response.data.currentDate)
        }
      }).catch((error) => {
        console.log(error)
      })
      axios.get(`${this.$api}/public-lists`).then((response) => {
        if (response.data.status === 'success') {
          this.$store.commit('updateZones', response.data.zones)
          this.$store.commit('updateRiderStatus', response.data.riderStatus)
          this.$store.commit('updateHorseStatus', response.data.horseStatus)
          this.$store.commit('updateProducts', response.data.products)
          this.$store.commit('updateDiscounts', response.data.discounts)
          this.$store.commit('updateBlocks', response.data.blocks)
          if (this.blocksCount > 0) {
            this.blocks = [...this.$store.state.blocks]
          }
        }
      }).catch((error) => {
        // eslint-disable-next-line
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard/Dashboard.vue